/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface WordExportParams
 */
export interface WordExportParams {
  /**
   *
   * @type {string}
   * @memberof WordExportParams
   */
  pic1: string;
  /**
   *
   * @type {string}
   * @memberof WordExportParams
   */
  pic2: string;
  /**
   *
   * @type {string}
   * @memberof WordExportParams
   */
  pic3: string;
  /**
   *
   * @type {string}
   * @memberof WordExportParams
   */
  pic4: string;
  /**
   *
   * @type {string}
   * @memberof WordExportParams
   */
  pic5: string;
  /**
   *
   * @type {string}
   * @memberof WordExportParams
   */
  pic6: string;
}

/**
 * Check if a given object implements the WordExportParams interface.
 */
export function instanceOfWordExportParams(value: object): value is WordExportParams {
  if (!('pic1' in value) || value['pic1'] === undefined) return false;
  if (!('pic2' in value) || value['pic2'] === undefined) return false;
  if (!('pic3' in value) || value['pic3'] === undefined) return false;
  if (!('pic4' in value) || value['pic4'] === undefined) return false;
  if (!('pic5' in value) || value['pic5'] === undefined) return false;
  if (!('pic6' in value) || value['pic6'] === undefined) return false;
  return true;
}

export function WordExportParamsFromJSON(json: any): WordExportParams {
  return WordExportParamsFromJSONTyped(json, false);
}

export function WordExportParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WordExportParams {
  if (json == null) {
    return json;
  }
  return {
    pic1: json['pic1'],
    pic2: json['pic2'],
    pic3: json['pic3'],
    pic4: json['pic4'],
    pic5: json['pic5'],
    pic6: json['pic6'],
  };
}

export function WordExportParamsToJSON(value?: WordExportParams | null): any {
  if (value == null) {
    return value;
  }
  return {
    pic1: value['pic1'],
    pic2: value['pic2'],
    pic3: value['pic3'],
    pic4: value['pic4'],
    pic5: value['pic5'],
    pic6: value['pic6'],
  };
}
